//// Application Packages
import React from 'react'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import { selectForms } from '../../reducers/formSlice'

//// Application Components
import StateSelectorComponent from '../conditional-components/state-selector-component'

//// Carbon Components
import {
    TextInput,
    TextArea,
    Select,
    SelectItem,
    DatePicker,
    DatePickerInput,
    Button,
} from '@carbon/react'

//// Carbon Icons
import { Subtract } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AdditionalDisciplineHistorySurrenderedComponent = ({
    number,
    handleData,
    handleSubtractAdditionalDisciplineHistoryForm,
}) => {
    //////// Hooks

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']
    const digital_sub_name = 'surrendered'

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <div>
                <h4>Additional Discipline (Surrendered):</h4>

                <TextInput
                    className="required"
                    labelText="Name of Agency:"
                    id={'RSD34C' + number}
                    name={'RSD34C' + number}
                    placeholder=""
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'RSD34C' + number
                        ]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'RSD34C' + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'RSD34C' + number + 'ErrMsg'
                        ]
                    }
                />

                <StateSelectorComponent
                    digital_name={digital_name}
                    digital_sub_name={digital_sub_name}
                    value_key={['STATEC' + number]}
                    country=""
                />

                <DatePicker
                    className="required"
                    dateFormat="m/d/Y"
                    datePickerType="single"
                    onChange={(e) => handleData(e, ['RSD36C' + number])}
                    onClose={(e) => handleData(e, ['RSD36C' + number])}
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'RSD36C' + number
                        ]
                    }
                >
                    <DatePickerInput
                        className="required"
                        labelText="Action Date:"
                        id={'RSD36C' + number}
                        name={'RSD36C' + number}
                        placeholder="MM/DD/YYYY"
                        type="text"
                        invalid={
                            formsData?.[digital_name]?.[digital_sub_name]
                                ?.errors?.['RSD36C' + number]
                        }
                        invalidText={
                            formsData?.[digital_name]?.[digital_sub_name]
                                ?.errors?.['RSD36C' + number + 'ErrMsg']
                        }
                    />
                </DatePicker>

                <TextInput
                    className="required"
                    labelText="Final Action:"
                    id={'FIN_ACTC' + number}
                    name={'FIN_ACTC' + number}
                    placeholder=""
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'FIN_ACTC' + number
                        ]
                    }
                    maxLength="60"
                    type="text"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'FIN_ACTC' + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'FIN_ACTC' + number + 'ErrMsg'
                        ]
                    }
                />

                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'RSD39C' + number
                        ]
                    }
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'RSD39C' + number
                        ]
                    }
                    helper=""
                    labelText="Under Appeal:"
                    id={'RSD39C' + number}
                    name={'RSD39C' + number}
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'RSD39C' + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'RSD39C' + number + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="Yes" value="Y" />
                    <SelectItem text="No" value="N" />
                    <SelectItem text="No Answer" value="NA" />
                </Select>

                <TextArea
                    className="required"
                    labelText="Applicant Statement:"
                    id={'LIC_NTSC' + number}
                    name={'LIC_NTSC' + number}
                    placeholder=""
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            'LIC_NTSC' + number
                        ]
                    }
                    maxLength="4000"
                    type="textarea"
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'LIC_NTSC' + number
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            'LIC_NTSC' + number + 'ErrMsg'
                        ]
                    }
                />

                <div className="half-width-button-with-icon-group">
                    <div className="half-width-button-with-icon-group-item">
                        <Button
                            className="fldoh-btn"
                            name={number}
                            type="button"
                            kind="danger"
                            size="md"
                            onClick={
                                handleSubtractAdditionalDisciplineHistoryForm
                            }
                        >
                            Remove
                            <Subtract />
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdditionalDisciplineHistorySurrenderedComponent
